import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, FileText, Eye, Download } from 'lucide-react';
import { getPlayerDocuments, documentViewUrl, documentDownloadUrl, DOCUMENT_CATEGORIES } from '../../api';

function fmtDate(d) {
  if (!d) return '—';
  return new Date(d).toLocaleDateString('nl-NL', { day: '2-digit', month: '2-digit', year: '2-digit' });
}

const CARD = { background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 14, padding: '14px 16px', marginBottom: 10 };

// playerRecord.id — same one threaded through every other player/* page via PlayerDataContext,
// never user-editable — is what scopes the fetch to just this player's own documents; the
// server route only ever returns rows for the player_id it's given.
export default function PersonalDocs({ playerRecord }) {
  const navigate = useNavigate();
  const [documents, setDocuments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [categoryFilter, setCategoryFilter] = useState('All');

  useEffect(() => {
    if (!playerRecord?.id) { setLoading(false); return; }
    getPlayerDocuments(playerRecord.id)
      .then(docs => setDocuments(docs || []))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [playerRecord?.id]);

  const visible = categoryFilter === 'All' ? documents : documents.filter(d => d.category === categoryFilter);

  return (
    <div style={{ padding: '14px 14px 24px' }}>
      <button onClick={() => navigate('/player/me')} style={{ display: 'flex', alignItems: 'center', gap: 4, background: 'none', border: 'none', color: 'var(--text-muted)', cursor: 'pointer', fontSize: 13, marginBottom: 16, padding: 0, fontFamily: 'inherit' }}>
        <ChevronLeft size={16} /> Back
      </button>

      <div style={{ fontSize: 17, fontWeight: 700, marginBottom: 16 }}>Personal docs</div>

      {loading ? (
        <div style={{ padding: 20, textAlign: 'center', color: 'var(--text-muted)' }}>Loading…</div>
      ) : documents.length === 0 ? (
        <div style={{ ...CARD, textAlign: 'center', color: 'var(--text-muted)' }}>
          <FileText size={28} style={{ marginBottom: 8, opacity: 0.5 }} />
          <div style={{ fontSize: 13 }}>No documents yet.</div>
        </div>
      ) : (
        <>
          <select value={categoryFilter} onChange={e => setCategoryFilter(e.target.value)}
            style={{ marginBottom: 12, padding: '7px 10px', borderRadius: 6, border: '1px solid var(--border)', background: 'var(--bg-card)', color: 'var(--text-secondary)', fontSize: 12, outline: 'none' }}>
            <option>All</option>
            {DOCUMENT_CATEGORIES.map(c => <option key={c}>{c}</option>)}
          </select>

          {visible.map(doc => (
            <div key={doc.id} style={CARD}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 10 }}>
                <div style={{ minWidth: 0 }}>
                  <div style={{ fontSize: 14, fontWeight: 700, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{doc.original_filename}</div>
                  <div style={{ fontSize: 12, color: 'var(--text-muted)', marginTop: 2 }}>{doc.category} · {fmtDate(doc.uploaded_at)}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                  <button onClick={() => window.open(documentViewUrl(doc.id), '_blank')} title="View"
                    style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, padding: '6px 10px', borderRadius: 6, border: '1px solid var(--border)', background: 'none', color: 'var(--text-secondary)', cursor: 'pointer' }}>
                    <Eye size={13} /> View
                  </button>
                  <a href={documentDownloadUrl(doc.id)} download
                    style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 12, padding: '6px 10px', borderRadius: 6, border: '1px solid var(--border)', background: 'none', color: 'var(--text-secondary)', cursor: 'pointer', textDecoration: 'none' }}>
                    <Download size={13} /> Download
                  </a>
                </div>
              </div>
              {doc.note && (
                <div style={{
                  marginTop: 10, paddingTop: 10, borderTop: '1px dashed var(--border)',
                  fontStyle: 'italic',
                  fontSize: 15, lineHeight: 1.4, color: '#4b5563',
                }}>
                  “{doc.note}”
                </div>
              )}
            </div>
          ))}
        </>
      )}
    </div>
  );
}
